import { Paper } from "@mui/material";
import "../styles/App.css";
import BookIcon from '@mui/icons-material/Book';
import TransformIcon from '@mui/icons-material/Transform';
import SubtitlesIcon from '@mui/icons-material/Subtitles';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { Link } from "react-router-dom";

const menuItems = [
  { to: "MaterialReservation", title: "Materialen Reservatie", Icon: BookIcon },
  { to: "SRTGenerator", title: "SRT Generator (AI)", Icon: SubtitlesIcon },
  { to: "SRTomzettenFCP", title: "SRT omzetten voor FCP", Icon: TransformIcon },
  { to: "UrenSchrijven", title: "Uren Schrijven (Gripp)", Icon: AccessTimeIcon }
];

export function HomePortal() {
  return (
    <div className="portal">
      {menuItems.map(({ to, title, Icon }) => (
        <Link to={to} style={{ color: 'inherit', textDecoration: 'none' }}>
          <Paper className="big-paper" elevation={7}>
            <h1>{title}</h1>
            <div className="portal-icon-container">
              <Icon className="portal-icon" />
            </div>
          </Paper>
        </Link>
      ))}
    </div>
  );
}
